// assets
import {
    IconDashboard,
    IconBrandChrome,
    IconHelp,
    IconUsers,
    IconUser,
    IconRoute,
    IconLayoutKanban,
    IconReport,
    IconSettings
} from '@tabler/icons';

// constant
const icons = { IconDashboard, IconBrandChrome, IconHelp, IconUsers, IconUser, IconRoute, IconLayoutKanban, IconReport, IconSettings };

// ==============================|| CUSTOMER MENU ITEMS ||============================== //

const customerMenuItems = [
    // {
    //     id: 'dashboard',
    //     type: 'group',
    //     children: [
    //         {
    //             id: 'default',
    //             title: 'Dashboard',
    //             type: 'item',
    //             url: '/dashboard',
    //             icon: icons.IconDashboard,
    //             breadcrumbs: false
    //         }
    //     ]
    // },
    {
        id: 'main-pages',
        type: 'group',
        children: [
            {
                id: 'profile',
                title: 'Profile',
                type: 'item',
                url: '/customer/customer-profile',
                icon: icons.IconUser,
                breadcrumbs: false
            },
            {
                id: 'reports',
                title: 'Reports',
                type: 'item',
                url: '/customer/collection-reports',
                icon: icons.IconReport,
                breadcrumbs: false
            }
            // {
            //     id: 'settings',
            //     title: 'Settings',
            //     type: 'item',
            //     url: '/sample-page',
            //     icon: icons.IconSettings,
            //     breadcrumbs: false
            // }
            // {
            //     id: 'plant',
            //     title: 'Plant',
            //     type: 'collapse',
            //     icon: icons.IconBuildingFactory,
            //     breadcrumbs: false,
            //     children: [
            //         {
            //             id: 'vendor',
            //             title: 'Vendors',
            //             type: 'item',
            //             url: '/vendors',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: 'materials',
            //             title: 'Materials',
            //             type: 'item',
            //             url: '/materials',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: 'vendor-invoices',
            //             title: 'Vendor Invoice',
            //             type: 'item',
            //             url: '/vendor-invoices',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: 'vendor-payment',
            //             title: 'Vendor Payments',
            //             type: 'item',
            //             url: '/vendor-payment',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: 'etp-records',
            //             title: 'ETP Records',
            //             type: 'item',
            //             url: '/etp-records',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: '/chemical-disinfection-log-sheet',
            //             title: 'Chemical Disinfection Log',
            //             type: 'item',
            //             url: '/chemical-disinfection-log-sheet',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: '/shredding-material-log-sheet',
            //             title: 'Shredding Material Log',
            //             type: 'item',
            //             url: '/shredding-material-log-sheet',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: '/autoclave-log-sheet',
            //             title: 'Autoclave Log',
            //             type: 'item',
            //             url: '/autoclave-log-sheet',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: '/vehicle-tracking',
            //             title: 'Vehicle Tracking',
            //             type: 'item',
            //             url: '/vehicle-tracking',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: '/bmw-received-log-sheet',
            //             title: 'BMW Received Log Sheets',
            //             type: 'item',
            //             url: '/bmw-received-log-sheet',
            //             breadcrumbs: false
            //         },
            //         {
            //             id: '/incineration-log-sheet',
            //             title: 'Incineration Log Sheets',
            //             type: 'item',
            //             url: '/incineration-log-sheet',
            //             breadcrumbs: false
            //         }
            //     ]
            // },
            // {
            //     id: 'plant-reports',
            //     title: 'Plant Reports',
            //     type: 'item',
            //     url: '/plant-reports',
            //     icon: icons.IconReport,
            //     breadcrumbs: false
            // }
        ]
    }
];

export default customerMenuItems;
